import types from "./types";

const INITIAL_STATE = {
  leadCustomerList: null,
  leadCustomerListError: null,
  leadCustomerListLoading: false,

  //create
  createLeadCustomer: null,
  createLeadCustomerError: null,
  createLeadCustomerLoading: false,

  //update
  updateLeadCustomer: null,
  updateLeadCustomerError: null,
  updateLeadCustomerLoading: false,

  //delete
  deleteLeadCustomer: null,
  deleteLeadCustomerError: null,
  deleteLeadCustomerLoading: false,

  //single item
  singleItem: null,
};

const LeadCustomerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_LEAD_CUSTOMER_START:
      return {
        ...state,
        leadCustomerList: null,
        leadCustomerListError: null,
        leadCustomerListLoading: true,
      };
    case types.GET_LEAD_CUSTOMER_SUCCESS:
      return {
        ...state,
        leadCustomerList: action.payload,
        leadCustomerListLoading: false,
      };
    case types.GET_LEAD_CUSTOMER_ERROR:
      return {
        ...state,
        leadCustomerListError: action.payload,
        leadCustomerListLoading: false,
      };
    case types.GET_LEAD_CUSTOMER_RESET:
      return {
        ...state,
        leadCustomerListError: null,
        leadCustomerListLoading: false,
      };
    //create

    case types.CREATE_LEAD_CUSTOMER_START:
      return {
        ...state,
        createLeadCustomer: null,
        createLeadCustomerError: null,
        createLeadCustomerLoading: true,
      };
    case types.CREATE_LEAD_CUSTOMER_SUCCESS:
      return {
        ...state,
        createLeadCustomer: action.payload,
        createLeadCustomerLoading: false,
      };
    case types.CREATE_LEAD_CUSTOMER_ERROR:
      return {
        ...state,
        createLeadCustomerError: action.payload,
        createLeadCustomerLoading: false,
      };
    case types.CREATE_LEAD_CUSTOMER_RESET:
      return {
        ...state,
        createLeadCustomerError: null,
        createLeadCustomerLoading: false,
      };
    //delete

    case types.DELETE_LEAD_CUSTOMER_START:
      return {
        ...state,
        deleteLeadCustomer: null,
        deleteLeadCustomerError: null,
        deleteLeadCustomerLoading: true,
      };
    case types.DELETE_LEAD_CUSTOMER_SUCCESS:
      return {
        ...state,
        deleteLeadCustomer: action.payload,
        deleteLeadCustomerLoading: false,
      };
    case types.DELETE_LEAD_CUSTOMER_ERROR:
      return {
        ...state,
        deleteLeadCustomerError: action.payload,
        deleteLeadCustomerLoading: false,
      };
    case types.DELETE_LEAD_CUSTOMER_RESET:
      return {
        ...state,
        deleteLeadCustomer: null,
        deleteLeadCustomerError: null,
        deleteLeadCustomerLoading: false,
      };

    //update
    case types.UPDATE_LEAD_CUSTOMER_START:
      return {
        ...state,
        updateLeadCustomer: null,
        updateLeadCustomerError: null,
        updateLeadCustomerLoading: true,
      };
    case types.UPDATE_LEAD_CUSTOMER_SUCCESS:
      return {
        ...state,
        updateLeadCustomer: action.payload,
        updateLeadCustomerLoading: false,
      };
    case types.UPDATE_LEAD_CUSTOMER_ERROR:
      return {
        ...state,
        updateLeadCustomerError: action.payload,
        updateLeadCustomerLoading: false,
      };
    case types.UPDATE_LEAD_CUSTOMER_RESET:
      return {
        ...state,
        updateLeadCustomer: null,
        updateLeadCustomerError: null,
        updateLeadCustomerLoading: false,
      };
    //singleItem
    case types.SINGLE_LEAD_CUSTOMER_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_LEAD_CUSTOMER_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LEAD_CUSTOMER_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_LEAD_CUSTOMER_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default LeadCustomerReducer;

